"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalStyles = exports.getContextStyles = exports.getTagStyle = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const utils_1 = require("@obvio/utils");
const theme_1 = require("../theme");
const fonts_1 = require("../theme/fonts");
const getFontStyle = (font) => (0, theme_1.css) `
    font-family: ${font} ${fontFallback(font)};
  `;
const getTagStyle = (tag, theme) => {
    var _a;
    const _b = (_a = theme.typography[tag]) !== null && _a !== void 0 ? _a : {}, { css: style } = _b, variants = __rest(_b, ["css"]);
    const kinds = (0, utils_1.keys)(variants);
    return (0, theme_1.css)(style &&
        (0, theme_1.css) `
        ${tag} {
          ${style}
        }
      `, ...kinds.map((kind) => (0, theme_1.css) `
        &[kind='${kind}'] {
          ${variants[kind]}
        }
      `));
};
exports.getTagStyle = getTagStyle;
function getContextStyles(ctxDef) {
    return [!!ctxDef.font && getFontStyle(ctxDef.font)];
}
exports.getContextStyles = getContextStyles;
function GlobalStyles() {
    return ((0, jsx_runtime_1.jsx)(theme_1.Global, { styles: (theme) => {
            return [
                theme.font &&
                    (0, theme_1.css) `
              html,
              body {
                ${getFontStyle(theme.font)};
              }
            `,
                theme.global,
            ];
        } }));
}
exports.GlobalStyles = GlobalStyles;
function fontFallback(font) {
    const fb = fonts_1.fontFallbacks[font];
    if (fb) {
        return `, ${fb}`;
    }
    if (!font.includes(',')) {
        console.warn(`WARNING: missing fallback fonts for "${font}"`);
    }
    return '';
}
